export const STEP_ONE_INITIAL_VALUES = {
    highest_education_level_id: null as any,
    course: null,
    specialization: null,
    college: null,
    education_type: "",
    completionYear: null,
    degreeMonth: null,
    degreeYear: null
};


export const EDUCATIONS = [
    { id: 4, level: "10th or Below 10th", ordered_id: 1 },
    { id: 6, level: "12th Pass", ordered_id: 2 },
    { id: 7, level: "Diploma", ordered_id: 3 },
    { id: 3, level: "ITI", ordered_id: 4 },
    { id: 1, level: "Graduate", ordered_id: 5 },
    { id: 2, level: "Post Graduate", ordered_id: 6 },
];

export const ITI_ID = EDUCATIONS.find(i => i.level === "ITI")!.id

export const EDUCATION_TYPE = [
    { label: "Full-time", value: "FullTime" },
    { label: "Part-time", value: "PartTime" },
    { label: "Correspondence", value: "Correspondence" },
];

export const EDUCATION_PAGES = {
    BASE_ROUTE: "/education",
}
